<br />

<div style="width: auto; overflow: auto">
  <app-common-list-table
    [request]="getRequest"
    [cols]="cols"
    actionButtonText="Añadir Salida"
    (actionButtonClick)="add()"
  >
    <ng-template #thEnd>
      <th>
        <p class="d-flex justify-content-center" style="margin-bottom: 0">
          Acciones
        </p>
      </th>
    </ng-template>

    <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
      <td>
        <app-action-buttons
          [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
          (editRowButtonEvent)="edit(data)"
          (deleteRowButtonEvent)="show('delete', data)"
          (showRowButtonEvent)="show('info', data)"
        >
        </app-action-buttons>
      </td>
    </ng-template>
  </app-common-list-table>
</div>

<app-modals
  [view]="this"
  [form]="formFields"
  [serverUrl]="serverUrl"
  [previousData]="model"
  [getRequest]="getRequest"
  [deleteRequest]="deleteRequest"
>
</app-modals>
